import { PermissionChecker } from "@utility/permission-checker";
export const usePermissions = () => {
    const hasPermission = (permission) => {
        return PermissionChecker.hasPermission(permission);
    };
    const hasAnyPermission = (permissions) => {
        return PermissionChecker.hasAnyPermission(permissions);
    };
    const hasAllPermissions = (permissions) => {
        return PermissionChecker.hasAllPermissions(permissions);
    };
    return {
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
    };
};
